(function() {
  const WIDGET_SELECTOR = '.salepify-embed-widget__embedded-list-container';
  let savedWidget = null;
  let isRestoring = false;

  // 1. Tìm vị trí mục tiêu để chèn widget (ngay dưới nút Add to Basket / form giỏ hàng)
  function getTargetElement() {
    // Ưu tiên vị trí cấu hình app block nếu có
    const customPlacement = document.querySelector('.salepify-embed-widget-placement, .salepify-embed-widget-block');
    if (customPlacement) return customPlacement;

    const selectors = [
      'form[action*="/cart/add"]:not([id*="installment"]):not([class*="installment"]):not(.payment-terms)',
      '.button-product-buy_buttons.button-product form[action*="/cart/add"]',
      '.product__quantity_buy-buttons',
      '.product-form-wrapper .buy-buttons-wrapper',
      'form[action*="/cart/add"] product-buy-buttons-element',
      'product-form form[action*="/cart/add"]',
      'product-form',
      '.product-form',
      '.product__info-container form[action*="/cart/add"]',
      'form[action*="/cart/add"]'
    ];

    for (let i = 0; i < selectors.length; i++) {
      const candidates = Array.from(document.querySelectorAll(selectors[i]));
      if (candidates.length > 0) {
        // Ưu tiên chọn form chính đang hiển thị, tránh sticky ATC bar ẩn
        const visible = candidates.find(el => el.offsetParent !== null && !el.closest('.sticky-atc, .product-sticky-bar, [class*="sticky"]'));
        return visible || candidates[0];
      }
    }
    return null;
  }

  // 2. Hàm khôi phục lại widget vào đúng vị trí
  function restoreWidget() {
    if (isRestoring) return;

    // Nếu widget đang hiển thị bình thường trên DOM thì lưu lại bản cache
    const currentOnDom = document.querySelector(WIDGET_SELECTOR);
    if (currentOnDom && document.body.contains(currentOnDom)) {
      savedWidget = currentOnDom;
      if (savedWidget.style.display === 'none') {
        savedWidget.style.display = '';
      }
      return;
    }

    // Nếu widget bị mất khỏi DOM sau khi chuyển variant
    if (savedWidget) {
      const target = getTargetElement();
      if (target) {
        isRestoring = true;
        try {
          target.insertAdjacentElement('afterend', savedWidget);
          if (savedWidget.style.display === 'none') {
            savedWidget.style.display = '';
          }
        } catch (err) {
          console.warn('[Salepify Fix] Error restoring widget:', err);
        } finally {
          setTimeout(() => { isRestoring = false; }, 60);
        }
        return;
      }
    }

    // Fallback: Nếu chưa kịp cache widget, gọi lại hàm init của app
    if (!savedWidget && window.tlFreeGiftOffer && window.tlFreeGiftOffer.embedWidget) {
      try {
        const ew = window.tlFreeGiftOffer.embedWidget;
        if (typeof ew.getTargetElements === 'function') {
          ew.targetElements = ew.getTargetElements();
        }
        if (typeof ew.initializeEmbedWidgetElement === 'function') {
          ew.initializeEmbedWidgetElement();
        }
      } catch (e) {
        // Silent catch
      }
    }
  }

  // 3. Sử dụng MutationObserver để phát hiện ngay khi theme re-render form sản phẩm
  const observer = new MutationObserver(() => {
    const currentWidget = document.querySelector(WIDGET_SELECTOR);
    if (currentWidget && document.body.contains(currentWidget)) {
      savedWidget = currentWidget;
    } else if (savedWidget && !document.body.contains(savedWidget)) {
      restoreWidget();
    }
  });

  function startObserver() {
    const mainContainer = document.querySelector('main') || document.body;
    if (mainContainer) {
      observer.observe(mainContainer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }

  // 4. Bắt các sự kiện click / change variant từ swatch và input của theme
  ['change', 'click', 'variant:change', 'variant:changed', 'shopify:section:load'].forEach(eventName => {
    document.addEventListener(eventName, (e) => {
      if (e.target && (
        e.target.matches?.('input[name="id"], select[name="id"], [data-variant-id], [data-value], .swatch, .swatch-element, .variant-input, [class*="variant"], [class*="swatch"]') ||
        e.target.closest?.('.swatches, .variant-wrapper, variant-radios, variant-selects, [class*="swatch"], [class*="variant"]')
      )) {
        setTimeout(restoreWidget, 50);
        setTimeout(restoreWidget, 250);
        setTimeout(restoreWidget, 500);
      }
    }, true);
  });

  // 5. Bắt sự kiện thay đổi URL (các theme Shopify thường cập nhật ?variant=... qua History API)
  const wrapHistory = (method) => {
    const orig = history[method];
    history[method] = function() {
      const res = orig.apply(this, arguments);
      setTimeout(restoreWidget, 100);
      setTimeout(restoreWidget, 350);
      return res;
    };
  };
  wrapHistory('pushState');
  wrapHistory('replaceState');
  window.addEventListener('popstate', () => setTimeout(restoreWidget, 100));
})();
